import * as React from "react"
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { HierarchicalTextBlock, ImageSkuBlock } from "@components"
import { useAdminProductReviewList } from "Pages/Admin/ProductReview/@hooks"
import { CategoryText, SkuInfoBlockWrap } from "../@components"
import { useAdminProductReviewListNew } from "Pages/Admin/ProductReviewNew/@hooks"


export default function associatedSkuColumn() {
	return [{
		name: "category", label: "Category",
		options: {
			display: 'excluded',
			customBodyRowRender: value => value || 'Not assigned'
		}
	}, {
		name: "skuBrand", label: "Brand",
		options: {
			display: 'excluded',
			customBodyRowRender: value => value || 'Not assigned'
		}
	}, {
		name: "matchedBy", label: "Matched By",
		options: {
			display: 'excluded',
		}
	}, {
		name: "skuName", label: "Associated SKU",
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: (value, rowData) => {
				return <RenderAssociatedSkuColumn value={value} row={rowData} />
			}
		}
	}, {
		name: 'skuID', label: 'Normalized?',
		options: {
			display: 'excluded', filterType: "checkbox",
			customBodyRowRender: value => !!value ? 'Yes' : 'No'
		}
	}, ]
}


function RenderAssociatedSkuColumn({ row, value }) {
	const { handleClickSkuMapping } = useAdminProductReviewListNew(row, row.date, row.siteID, row.productID, row.skuID)

	const isMapped = !!row.skuID
	const matchedBy = row.matchedBy
	const isUnnormalized = matchedBy === 'Unnormalized'

	const colorByMatched = {
		Skip: 'secondary.darker',
		IA: 'notice.main',
		QA: 'info.main',
		Normalized: 'success.main',
		Unnormalized: 'error.dark'
	}
	const matchedByColor = colorByMatched[matchedBy]

	return <Box sx={{ display: 'flex', alignItems: 'left' }}>
		{isMapped
		? <ImageSkuBlock
			skuID={row?.skuID}
			skuName={value}
			hideName
			isClickable
			sx={{ mr: 2 }}
			secondaryBoxStyle={{ "span": { position: 'unset' } }}
		  />
		: <Box
			sx={{
				width: 100,
				height: 100,
				position: 'relative',
				overflow: 'hidden',
				margin: '0 auto',
			}}
		  />
	}
		<Box sx={{ display: 'flex', flexDirection: 'column', ml: 2, width: 300 }}>
			<SkuInfoBlockWrap sku={value} category={row.category} brand={row.skuBrand} />
			<HierarchicalTextBlock
				supertitle="SKU ID: "
				supertitleValue={row.skuID}
				title={ isUnnormalized ? '' : 'Matched by: ' }
				titleValue={<CategoryText label={matchedBy} color={matchedByColor} />}
			/>
			{!!row.IAIdSku && <Box onClick={handleClickSkuMapping} sx={{ display: 'flex', alignItems: 'baseline', columnGap: '3px', cursor: "pointer"}}>
			<IconSeeker icon="circle-info" tooltip="View details" />
			<Typography variant="body2" sx={{ display: "inline", fontSize: "0.8rem" }}>
				Show Sku Mapping
			</Typography>
		</Box>}
		</Box>
	</Box>
}
